import { useLocalStorage } from "usehooks-ts";
import { Session } from "./http.models";

type SessionState = {
  sessions: Session[];
}

type SessionActions = {
  setSessions: (sessions: Session[]) => void;
  addSession: (session: Session) => void;
  removeSession: (sessionId: string) => void;
  setSessionTitle: (sessionId: string, title: string) => void;
  sessionById: (sessionId: string) => Session | undefined;
}

export default function SessionModel() {
  const [sessions, setSessions, _] = useLocalStorage<Session[]>('chat_sessions', []);

  const addSession = (session: Session) => {
    setSessions([session, ...sessions]);
  }

  const removeSession = (sessionId: string) => {
    setSessions(sessions.filter(session => session.id !== sessionId));
  }

  const setSessionTitle = (sessionId: string, title: string) => {
    setSessions(
      sessions.map(session => session.id === sessionId 
        ? { ...session, title } 
        : session
      )
    );
  }

  const sessionById = (sessionId: string) => sessions.find(session => session.id === sessionId);

  return {
    sessions,
    setSessions,
    addSession,
    removeSession,
    setSessionTitle,
    sessionById,
  } as SessionState & SessionActions;
}